namespace $ {

	export class $shm_hitalama_map_tap {
		private pointers = new Set< number >()
		private started: { event: PointerEvent, target: Element } | null = null
		private previous: { event: PointerEvent, target: Element } | null = null

		start( event: PointerEvent, target: Element | null ) {
			this.pointers.add( event.pointerId )
			this.started = target && this.pointers.size === 1 ? { event, target } : null
			if( !this.started ) this.previous = null
		}

		move( event: PointerEvent ) {
			const start = this.started?.event
			if( !start || start.pointerId !== event.pointerId ) return
			if( Math.hypot( event.clientX - start.clientX, event.clientY - start.clientY ) <= 8 ) return
			this.started = this.previous = null
		}

		end( event: PointerEvent ) {
			this.pointers.delete( event.pointerId )
			this.move( event )
			const start = this.started
			if( !start || start.event.pointerId !== event.pointerId ) return null
			this.started = null
			if( event.timeStamp - start.event.timeStamp > 350 ) {
				this.previous = null
				return null
			}
			const previous = this.previous
			this.previous = { event, target: start.target }
			if( !previous || previous.target !== start.target ) return null
			if( event.timeStamp - previous.event.timeStamp > 350 ) return null
			if( Math.hypot( event.clientX - previous.event.clientX, event.clientY - previous.event.clientY ) > 24 ) return null
			this.previous = null
			return start.target
		}

		cancel( event: PointerEvent ) {
			this.pointers.delete( event.pointerId )
			this.started = this.previous = null
		}
	}

}
